export const isSmallScreenDevice = (): boolean => {
    return window.matchMedia("(orientation: landscape) and (max-width: 950px) and (max-height: 500px), (orientation: portrait) and (max-width: 650px)").matches;
};
